/* eslint-disable @typescript-eslint/no-explicit-any */

import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { UserSelectDropdown } from "./toolkit/user-select-dropdown";
import {
  ChevronLeft,
  Columns3Icon,
  PencilIcon,
  SaveIcon,
  Trash2,
} from "lucide-react";
import { useIgnorePriceValidation } from "./toolkit/use-ignore-price-validation";
import { useConfirmDialog } from "@/hooks/use-confirm-dialog";
import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { createPortal } from "react-dom";
import { ReactTable } from "../react-tables";
import { useTable } from "@/hooks/useTable";
import { TableColumnsHandle } from "@/components/shared/table-columns-handle";
import { useProcess } from "@/global-data";

export const IgnorePriceValidationsV2 = ({
  list,
  value,
  onChange,
  sku_list,
  onSubmit,
}: any) => {
  const {
    customerMap,
    handleAddUser,
    onChangeHandler,
    displayList,
    showMore,
    setShowMore,
    sortKey,
    sortOrder,
    sortedKeys,
    handleToggleForDeletion,
    removeSelectedUsers,
    selectedForDeletion,
    handleSorting,
    deleteSelectionToggle,
  } = useIgnorePriceValidation({ list, value, onChange });
  const { setProcess } = useProcess();
  const { confirm, dialog } = useConfirmDialog();
  const [searchText, setSearchText] = useState("");
  const [formOpen, setFormOpen] = useState(false);
  const element = document.getElementById(
    "ignore-price-validations-wrapper",
  ) as any;
  const [tableColumn, setTableColumn] = useState([
    "customer_name",
    "customer_id",
    "sku",
  ]);

  const { tableHeader, table, tableKeys, onResize, onSorting } = useTable({
    data: [],
    view: ["customer_name", "customer_id", "sku"],
    verifyKey: "ipv-table",
    visible: tableColumn,
    avoid: [""],
  });

  useEffect(() => {
    if (!formOpen) {
      setSearchText("");
    }
  }, [formOpen]);

  return (
    <>
      <div className="pl-[35px] flex items-center gap-[45px] py-4">
        <Label className="w-[180px]">Ignore Price Validations</Label>
        <div className="border rounded-md px-2 flex  flex-col gap-2 w-full relative py-2 min-h-[40px] pr-[40px]">
          {displayList?.map((item: any, index: number) => {
            if (index > 1 && !showMore) return null;
            return (
              <div
                key={index}
                className="bg-gray-50 border text-xs rounded-sm px-1 py-1"
              >
                {customerMap[item] ? `${customerMap[item]} (${item})` : item}
              </div>
            );
          })}
          {displayList.length > 2 && (
            <Button
              type="button"
              onClick={() => setShowMore((prev: boolean) => !prev)}
              className="w-[100px] p-0 h-auto py-2 text-xs"
            >
              {showMore ? "Show Less" : "Show More"}
            </Button>
          )}
          <div
            onClick={() => setFormOpen(true)}
            className="absolute right-1 top-1"
          >
            <Button type="button" variant="ghost" className="px-2 h-auto py-2">
              <PencilIcon size={16} />
            </Button>
          </div>
        </div>
      </div>
      {formOpen
        ? createPortal(
            <div className="absolute left-0 top-0 w-full h-full ">
              <div className="w-full h-full bg-white rounded-[12px] border Z-[99999] relative inline-block">
                <div className="flex items-center justify-between border-b px-3 py-3">
                  <div className="flex items-center gap-3">
                    <h3 className="font-semibold leading-none tracking-tight">
                      Ignore Price Validations
                    </h3>
                    <div>
                      <Input
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        placeholder="Search..."
                        className="min-w-[300px]"
                        type="search"
                      />
                    </div>
                  </div>
                  <div className="flex gap-2">
                    <Button
                      type="submit"
                      onClick={async () => {
                        setProcess(true);
                        await onSubmit();
                        setProcess(false);
                      }}
                    >
                      <SaveIcon /> Save
                    </Button>
                    <TableColumnsHandle
                      tableKeys={tableKeys}
                      tableColumn={tableColumn}
                      setTableColumn={setTableColumn}
                      onSorting={onSorting}
                      labels={{
                        email_id: "Email ID",
                        enable: "Status",
                        modified_by: "Modified By",
                      }}
                    >
                      <Columns3Icon /> Column
                    </TableColumnsHandle>
                    <UserSelectDropdown
                      list={list}
                      onChange={handleAddUser}
                      selectedValue={value ? Object.keys(value) : []}
                    >
                      <Button type="button" variant={"action"}>
                        Add Customer
                      </Button>
                    </UserSelectDropdown>
                    <Button
                      type="button"
                      variant={"action"}
                      onClick={(e) => {
                        e.stopPropagation();
                        setFormOpen(false);
                      }}
                    >
                      <ChevronLeft /> Back
                    </Button>
                    <Button
                      type="button"
                      variant="destructive"
                      onClick={async () => {
                        confirm({
                          title: "Delete Customers",
                          description:
                            "Are you sure you want to delete the selected customers from Ignore Price Validations",
                        }).then((res) => {
                          if (res) {
                            removeSelectedUsers();
                          }
                        });
                      }}
                      disabled={selectedForDeletion.length === 0}
                    >
                      <Trash2 size={16} />
                    </Button>
                  </div>
                </div>

                <div className="overflow-y-auto md:h-[calc(100dvh-245px)]">
                  <ReactTable
                    tableHeader={tableHeader}
                    onResize={onResize}
                    table={table}
                    onAction={() => {}}
                    tableKeys={tableKeys}
                    sortedKeys={sortedKeys}
                    value={value}
                    customerMap={customerMap}
                    searchText={searchText}
                    selectedForDeletion={selectedForDeletion}
                    handleToggleForDeletion={handleToggleForDeletion}
                    onChangeHandler={onChangeHandler}
                    sku_list={sku_list}
                    handleSorting={handleSorting}
                    sortOrder={sortOrder}
                    sortKey={sortKey}
                    deleteSelectionToggle={deleteSelectionToggle}
                  />
                </div>
              </div>
            </div>,
            element,
          )
        : null}

      {dialog}
    </>
  );
};
